export const environment = {
  production: false,
  dev: true,
  apiUrl: 'https://devclientapi.brandmonitor.ru/api/',
  imagesCdnApiUrl: 'https://images-cdn.b-monitor.ru/',
  siteUrl: 'https://devclient.brandmonitor.ru/',
  extensionUrl: 'https://devclientext.brand-monitor.com',
  url: '',
  apiVersion: 'v2',
  permissions: {
      online: true,
      offline: true,
      recovery: true,
      kitchenAidDashboard: true,
  },
  amplitudeKey: '0c6f0236fdcc497d1174160d3f611ff3'
};
